<div class="flex flex-col gap-4 p-4 md:p-4 h-full overflow-y-auto">
    <!-- Header: Generate analysis, search, view controls, Generate analysis excel -->
    <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 flex-shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center gap-3 flex-1 min-w-0">
            <app-button severity="primary" label="Generate analysis" icon="pi pi-plus" iconPosition="left"
                (clicked)="onGenerateAnalysis()" class="flex-shrink-0" />
            <div class="min-w-0 flex-1 max-w-md sm:max-w-sm">
                <app-search-bar placeholder="Search analysis name" width="100%" [(ngModel)]="searchAnalysisName"
                    (searchChange)="onSearchAnalysisName()" />
            </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0">
            <!-- Configurations gear button -->
            <app-button variant="outlined" severity="contrast" label="Configuration" icon="sliders-horizontal"
                [iconSource]="'lucide'" iconPosition="left" class="flex-shrink-0"
                (clicked)="openConfigurationsDrawer()" />
            <app-select-button [options]="viewModeOptions" [(ngModel)]="viewMode"
                (selectionChange)="onViewModeChange($event)" size="small">
            </app-select-button>
            <app-popover #sortOverlay width="12rem">
                <ng-template #trigger>
                    <app-button variant="outlined" severity="contrast" icon="pi pi-sort-alt" iconPosition="left" />
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col text-sm text-gray-800">
                        <app-button variant="text" severity="contrast" label="Analysis name"
                            class="w-full justify-between"
                            [ngClass]="{ 'bg-arena-orange-100 text-black': sortField === 'reportName' }"
                            (clicked)="setSortField('reportName')">
                            @if (sortField === 'reportName') {
                            <i class="pi pi-check text-orange-500 text-xs ml-auto"></i>
                            }
                        </app-button>
                        <app-button variant="text" severity="contrast" label="Date created"
                            class="w-full justify-between"
                            [ngClass]="{ 'bg-arena-orange-100 text-black': sortField === 'createdAt' }"
                            (clicked)="setSortField('createdAt')">
                            @if (sortField === 'createdAt') {
                            <i class="pi pi-check text-orange-500 text-xs ml-auto"></i>
                            }
                        </app-button>
                        <app-button variant="text" severity="contrast" label="Due date" class="w-full justify-between"
                            [ngClass]="{ 'bg-arena-orange-100 text-black': sortField === 'dueDate' }"
                            (clicked)="setSortField('dueDate')">
                            @if (sortField === 'dueDate') {
                            <i class="pi pi-check text-orange-500 text-xs ml-auto"></i>
                            }
                        </app-button>
                    </div>
                    <hr class="my-2" />
                    <div class="flex flex-col text-sm text-gray-800">
                        <app-button variant="text" severity="contrast" label="Ascending" icon="pi pi-arrow-down"
                            iconPosition="right" class="w-full justify-between"
                            [ngClass]="{ 'bg-arena-orange-100 text-black': sortOrder === 'asc' }"
                            (clicked)="setSortOrder('asc')" />
                        <app-button variant="text" severity="contrast" label="Descending" icon="pi pi-arrow-up"
                            iconPosition="right" class="w-full justify-between"
                            [ngClass]="{ 'bg-arena-orange-100 text-black': sortOrder === 'desc' }"
                            (clicked)="setSortOrder('desc')" />
                    </div>
                </ng-template>
            </app-popover>
            <app-button variant="outlined" severity="contrast" icon="pi pi-filter" (clicked)="toggleFilterPanel()" />
        </div>
    </div>

    <!-- Analysis list/grid -->
    <div class="flex-1 min-h-0 flex flex-col">
        @if (!loadingAnalyses() && analysisItems.length === 0) {
        <div class="flex flex-col items-center justify-center h-full gap-4">
            <img class="z-10 mx-auto" [src]="'images/bob_agent/top-left-point-bob.svg' | assetUrl" alt="" height="200"
                width="200" draggable="false">

            <p class="text-sm text-gray-600">Click “+ Generate analysis”</p>
        </div>
        } @else {
        <app-grid-list-view [items]="analysisItems" [viewMode]="viewMode" [gridItemTemplate]="gridItemTemplate"
            [dataKey]="'id'" [scrollable]="true" [rows]="rows" [rowsPerPageOptions]="[20, 30, 40]"
            [useDataTable]="viewMode === 'list'" [tableColumns]="tableColumns" [tableConfig]="tableConfig"
            [customTemplates]="templatesMap" [totalRecords]="totalRecords" [first]="first" [showPaginator]="true"
            (pageChange)="onPageChange($event)" (rowClick)="onAnalysisRowClick($event)"
            [parentClass]="'flex-1 flex flex-col min-h-0'" [itemsLoading]="tableConfig.loading || false">
        </app-grid-list-view>

        <!-- Grid item template -->
        <ng-template #gridItemTemplate let-item>
            <div (click)="onAnalysisRowClick(item)"
                class="rounded-base border border-gray-200 shadow-sm flex flex-col cursor-pointer hover:shadow-md transition w-full h-full overflow-hidden">
                <div class="p-3 flex flex-col gap-2 flex-1 justify-between">
                    <div class="flex flex-col gap-2">
                        <div class="flex justify-between items-start">

                            <div class="flex items-center gap-2">
                                <div
                                    class="rounded-base px-2 py-1 flex items-center justify-center truncate max-w-[6.25rem] theme-text-border">
                                    <span class="theme-text text-xs font-medium">Start</span>
                                </div>
                            </div>

                            <div class="flex items-center gap-1">
                                @if (item.status == "PROCESSING") {
                                <div class="flex items-center justify-center w-8 h-8"
                                    (click)="$event.stopPropagation()">
                                    <img src="icons/template-library/generation_in_progress.svg" alt="Processing"
                                        class="w-4 h-4 animate-spin" pTooltip="Processing">
                                </div>
                                }@else if (canShowKebabMenu(item.currentUserRole)){
                                <app-menu #cardMenuRef [items]="cardMenuItems"
                                    (itemSelected)="onCardMenuAction($event)">
                                    <app-button type="button" variant="text" severity="contrast"
                                        (clicked)="$event.stopPropagation(); onCardMenuButtonClick($event, item, cardMenuRef)"
                                        [icon]="'pi pi-ellipsis-v'" iconSource="primeng" />
                                </app-menu>
                                }
                            </div>
                        </div>

                        <div class="text-sm font-semibold text-gray-900 truncate-2-lines" [pTooltip]="item.reportName"
                            [title]="item.reportName">
                            {{ item.reportName }}
                        </div>
                    </div>

                    @if (item.milestoneDate) {
                    <div class="flex items-center gap-2 text-xs text-gray-600 min-w-0">
                        <i class="pi pi-flag text-arena-orange flex-shrink-0"></i>

                        <span class="truncate min-w-0" [title]="item.milestoneName">
                            {{ item.milestoneName }}
                        </span>

                        <span class="text-gray-400 flex-shrink-0">•</span>

                        <span
                            class="rounded-base bg-arena-orange-100 text-arena-orange py-1 px-2 whitespace-nowrap flex-shrink-0">
                            {{ item.milestoneDate }}
                        </span>
                    </div>
                    } @else {
                    <div class="text-xs text-gray-400 italic flex items-center gap-2">
                        <i class="pi pi-flag"></i>
                        <span>No upcoming milestones</span>
                    </div>
                    }

                    <div class="flex flex-row flex-wrap justify-between items-center gap-2">
                        <div class="flex items-center gap-2 min-w-0 flex-1">
                            <app-icon [type]="'folder-closed'" [source]="'lucide'" [size]="'sm'"
                                [class]="item.projectName && item.projectName !== '—' ? 'text-blue-500' : 'text-gray-400 flex-shrink-0'" />
                            <span class="text-xs truncate min-w-0"
                                [class]="item.projectName && item.projectName !== '—' ? 'text-gray-800' : 'text-gray-400'"
                                [pTooltip]="item.projectName || 'No project'">
                                {{ item.projectName && item.projectName !== '—' ? item.projectName : 'No project' }}
                            </span>
                        </div>

                        <div class="flex items-center flex-shrink-0">
                            <app-avatar-stack [users]="item.assignedUsers" [visibleAvatars]="2" size="xs" />
                        </div>
                    </div>

                </div>

                <div class="border-t mx-3"></div>

                <div class="flex items-center gap-1.5 px-3 py-3 text-xs text-gray-500">
                    <app-icon [type]="'pi pi-refresh'" [source]="'primeng'" [size]="'sm'"></app-icon>
                    <span>Last edited on {{ item.lastEditedOn }} by {{ item.lastEditedBy }}</span>
                </div>

            </div>
        </ng-template>
        }
    </div>

    <!-- List/table view column templates (outside @else so ViewChild refs are always available) -->
    <ng-template #reportNameTemplateRef let-item="$implicit">
        <div class="font-medium text-gray-900 truncate max-w-[14rem]">{{ item.reportName }}</div>
    </ng-template>
    <ng-template #projectNameTemplateRef let-item="$implicit">
        <div class="text-sm text-gray-700 truncate max-w-[12rem]" [title]="item.projectName">{{ item.projectName }}
        </div>
    </ng-template>
    <ng-template #creatorNameTemplateRef let-item="$implicit">
        <div class="flex items-center gap-2 text-sm text-gray-700">
            <app-avatar-stack [users]="item.assignedUsers" [visibleAvatars]="1" size="xs" />
            <span class="truncate">{{ item.creatorName }}</span>
        </div>
    </ng-template>
    <ng-template #createdDateTemplateRef let-item="$implicit">
        <div class="flex items-center gap-2 text-sm text-gray-700">
            <app-icon [type]="'pi pi-calendar'" [source]="'primeng'" [size]="'sm'" class="text-gray-400"></app-icon>
            <span>{{ item.createdAt ? (item.createdAt | date: 'd MMMM yyyy') : '—' }}</span>
        </div>
    </ng-template>
    <ng-template #statusTemplateRef let-item="$implicit">
        <div class="rounded-base px-2 py-1 flex items-center justify-center truncate max-w-[6.25rem] theme-text-border">
            <span class="theme-text text-xs font-medium">Start</span>
        </div>
    </ng-template>
    <ng-template #upcomingMilestoneTemplateRef let-item="$implicit">
        <div class="text-sm text-gray-700">
            @if (item.milestoneDate) {
            <span class="truncate" [title]="item.milestoneName">{{ item.milestoneName }}</span>
            <span class="text-gray-400"> • </span>
            <span
                class="rounded bg-arena-orange-100 text-arena-orange px-2 py-0.5 text-xs font-medium whitespace-nowrap">{{
                item.milestoneDate }}</span>
            } @else {
            <span class="text-gray-400 italic">No upcoming milestone</span>
            }
        </div>
    </ng-template>
    <ng-template #dueDateTemplateRef let-item="$implicit">
        <div class="flex items-center gap-2 text-sm text-gray-700">
            <app-icon [type]="'pi pi-calendar'" [source]="'primeng'" [size]="'sm'" class="text-gray-400"></app-icon>
            <span>{{ item.dueDate ? (item.dueDate | date: 'd MMMM yyyy') : '—' }}</span>
        </div>
    </ng-template>
    <ng-template #actionsTemplateRef let-item="$implicit">
        @if (item.status == "PROCESSING") {
        <div class="flex items-center justify-center w-8 h-8" (click)="$event.stopPropagation()">
            <img src="icons/template-library/generation_in_progress.svg" alt="Processing" class="w-4 h-4 animate-spin"
                pTooltip="Processing">
        </div>
        } @else if (canShowKebabMenu(item.currentUserRole)) {
        <app-menu #tableMenuRef [items]="cardMenuItems" (itemSelected)="onCardMenuAction($event)">
            <app-button type="button" variant="text" severity="contrast"
                (clicked)="$event.stopPropagation(); onCardMenuButtonClick($event, item, tableMenuRef)"
                [icon]="'pi pi-ellipsis-v'" iconSource="primeng" />
        </app-menu>
        }
    </ng-template>
</div>

<p-menu #cardMenu [model]="cardMenuItems" [popup]="true" appendTo="body"
    (onSelect)="onCardMenuAction($any($event))"></p-menu>

@if (showDeleteDialog && selectedCardItem) {
<app-delete-confirmation [(visible)]="showDeleteDialog" [headerText]="'Delete ' + selectedCardItem.reportName + '?'"
    bodyText="This will permanently delete the analysis report and all associated data." confirmButtonText="Yes, delete"
    [closable]="!deletingAnalysis" [loading]="deletingAnalysis" (onConfirm)="confirmDeleteAnalysis()">
</app-delete-confirmation>
}

<app-dialog [(visible)]="renameCardDialogVisible" class="max-w-sm">
    <ng-template #headerTemplate>
        <h3 class="text-base font-semibold">Rename</h3>
    </ng-template>
    <div class="flex flex-col gap-3 py-2">
        <input pInputText type="text" [(ngModel)]="renameCardValue" placeholder="Enter new name" class="w-full"
            (keydown.enter)="onRenameCardConfirm()" />
    </div>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end gap-2">
            <app-button variant="outlined" (clicked)="renameCardDialogVisible = false">Cancel</app-button>
            <app-button variant="primary" [disabled]="!renameCardValue.trim()" [loading]="renamingCard"
                (clicked)="onRenameCardConfirm()">Rename</app-button>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="cardDueDateDialogVisible" class="max-w-sm">
    <ng-template #headerTemplate>
        <h3 class="text-base font-semibold">Select the due date</h3>
    </ng-template>
    <div class="flex flex-col gap-3 py-2">
        <app-datepicker [(value)]="cardDueDateValue" [config]="{
            placeholder: 'Select due date',
            showIcon: true,
            dateFormat: 'dd M yy',
            appendTo: 'body'
        }" />
    </div>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end gap-2">
            <app-button variant="outlined" (clicked)="cardDueDateDialogVisible = false">Cancel</app-button>
            <app-button variant="primary" [loading]="settingCardDueDate"
                (clicked)="onSetCardDueDateConfirm()">Save</app-button>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showUnsavedChangesDialog" [showCloseButton]="false" class="max-w-md">
    <ng-template #headerTemplate>
        <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2">
                <app-icon type="triangle-alert" class="text-orange-500 flex-shrink-0" [size]="'default'"></app-icon>
                <h3 class="text-base font-semibold">Unsaved changes</h3>
            </div>
            <p class="text-sm text-muted-foreground">You have unsaved changes. Continuing will discard all unsaved
                changes.</p>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end gap-2">
            <app-button variant="outlined" (clicked)="onUnsavedChangesCancel()">Cancel</app-button>
            <app-button variant="primary" (clicked)="onUnsavedChangesContinue()">Continue</app-button>
        </div>
    </ng-template>
</app-dialog>

@if(showGenerateAnalysisStepper && stepperConfig()) {
<app-stepper [config]="stepperConfig()!" [visible]="showGenerateAnalysisStepper"
    [disableNextButton]="(currentStepIndex() === 0 && (reportsFiles.length === 0 || !formulaeFile || !analysisExcelFile)) || (currentStepIndex() === 1 && !isProjectInfoValid)"
    [finishButtonLoading]="savingAnalysis()" [interceptClose]="shouldInterceptStepperClose"
    (stepChange)="onAnalysisStepChange($event)" (nextStepClick)="onAnalysisNextStepClick()"
    (previousStepClick)="onAnalysisPreviousStepClick()" (finish)="onAnalysisFinish()" (close)="onStepperClose()"
    (closeRequested)="onStepperCloseRequest()">

    <!-- Step 1: Lay the foundation -->
    <div *stepperStep="stepperConfig()!.steps[0]">
        <div class="flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto lay-foundation-accordion">
            <!-- Reports accordion -->
            <p-accordion [(value)]="reportsAccordionValue"
                class="w-full border border-gray-200 rounded-xl overflow-hidden">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <div class="flex items-center justify-between gap-2 flex-wrap w-full pr-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-semibold text-gray-900">Reports <span
                                        class="text-red-500">*</span></span>
                                <span class="flex items-center justify-center cursor-help"
                                    (click)="$event.stopPropagation()"
                                    [pTooltip]="'Upload all reports to be used for the analysis. Allowed: .pdf, .docx, .zip (with docx/pdf inside)'"
                                    tooltipPosition="top">
                                    <app-icon type="info" source="lucide" size="sm" class="text-gray-600"></app-icon>
                                    @if (reportsFiles.length > 0) {
                                    <div class="ml-2">
                                        <app-icon type="check" source="lucide" size="default"
                                            class="text-white bg-green-700 rounded-full p-1 "></app-icon>
                                    </div>
                                    }
                                </span>
                            </div>
                            <app-button variant="outlined" severity="contrast" label="Upload" icon="pi pi-upload"
                                iconPosition="left" (clicked)="openFileSelectionFor('reports')"
                                (click)="$event.stopPropagation()" class="flex-shrink-0"></app-button>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col gap-3 pt-1">
                            <app-attachment-group [attachments]="reportsFilesAsChatAttachments"
                                [maxVisibleAttachments]="5" [canRemove]="true" [chips]="geoAttachmentChips"
                                (removeAttachment)="onRemoveReportsAttachment($event)">
                            </app-attachment-group>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>

            <!-- Formulae accordion -->
            <p-accordion [(value)]="formulaeAccordionValue"
                class="w-full border border-gray-200 rounded-xl overflow-hidden">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <div class="flex items-center justify-between gap-2 flex-wrap w-full pr-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-semibold text-gray-900">Formulas <span
                                        class="text-red-500">*</span></span>
                                <span class="flex items-center justify-center cursor-help"
                                    (click)="$event.stopPropagation()" [pTooltip]="FORMULAE_TOOLTIP"
                                    tooltipPosition="top">
                                    <app-icon type="info" source="lucide" size="sm" class="text-gray-600"></app-icon>
                                    @if (formulaeFile) {
                                    <div class="ml-2">
                                        <app-icon type="check" source="lucide" size="default"
                                            class="text-white bg-green-700 rounded-full p-1 "></app-icon>
                                    </div>
                                    }
                                </span>
                            </div>
                            <div class="flex items-center gap-3 flex-shrink-0" (click)="$event.stopPropagation()">
                                @if (formulaeFile && !editingAnalysisId) {
                                <div class="flex items-center gap-1.5">
                                    <span class="text-xs whitespace-nowrap"
                                        [ngClass]="setFormulaeAsDefault ? 'text-green-600' : 'text-gray-500'">{{
                                        setFormulaeAsDefault ? 'Default' : 'Set as default' }}</span>
                                    <button type="button" (click)="setFormulaeAsDefault = !setFormulaeAsDefault"
                                        class="relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus:outline-none"
                                        [ngClass]="setFormulaeAsDefault ? 'bg-green-500' : 'bg-gray-200'">
                                        <span
                                            class="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
                                            [ngClass]="setFormulaeAsDefault ? 'translate-x-4' : 'translate-x-0'"></span>
                                    </button>
                                </div>
                                }
                                <app-button variant="outlined" severity="contrast" label="Upload" icon="pi pi-upload"
                                    iconPosition="left" (clicked)="openFileSelectionFor('formulae')"></app-button>
                            </div>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col gap-3 pt-1">
                            <p class="text-xs text-gray-500">Download the example file <a
                                    (click)="downloadSample(GEOTECHNICAL_SAMPLE_DOWNLOAD_TYPE.EXAMPLE_FORMULA)"
                                    class="text-arena-orange hover:underline cursor-pointer">from here</a> and standard
                                file <a (click)="downloadSample(GEOTECHNICAL_SAMPLE_DOWNLOAD_TYPE.STANDARD_FORMULA)"
                                    class="text-arena-orange hover:underline cursor-pointer">from here</a>.</p>
                            <app-attachment-group [attachments]="formulaeFileAsChatAttachments"
                                [maxVisibleAttachments]="1" [canRemove]="true" [chips]="geoAttachmentChips"
                                (removeAttachment)="onRemoveFormulaeAttachment()">
                            </app-attachment-group>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>

            <!-- Analysis excel accordion -->
            <p-accordion [(value)]="analysisExcelAccordionValue"
                class="w-full border border-gray-200 rounded-xl overflow-hidden">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <div class="flex items-center justify-between gap-2 flex-wrap w-full pr-2">
                            <div class="flex items-center gap-2">
                                <span class="text-sm font-semibold text-gray-900">Analysis excel <span
                                        class="text-red-500">*</span></span>
                                <span class="flex items-center justify-center cursor-help"
                                    (click)="$event.stopPropagation()" [pTooltip]="ANALYSIS_EXCEL_TOOLTIP"
                                    tooltipPosition="top">
                                    <app-icon type="info" source="lucide" size="sm" class="text-gray-600"></app-icon>
                                    @if (analysisExcelFile) {
                                    <div class="ml-2">
                                        <app-icon type="check" source="lucide" size="default"
                                            class="text-white bg-green-700 rounded-full p-1 "></app-icon>
                                    </div>
                                    }
                                </span>
                            </div>
                            <div class="flex items-center gap-3 flex-shrink-0" (click)="$event.stopPropagation()">
                                @if (analysisExcelFile && !editingAnalysisId) {
                                <div class="flex items-center gap-1.5">
                                    <span class="text-xs whitespace-nowrap"
                                        [ngClass]="setAnalysisExcelAsDefault ? 'text-green-600' : 'text-gray-500'">{{
                                        setAnalysisExcelAsDefault ? 'Default' : 'Set as default' }}</span>
                                    <button type="button"
                                        (click)="setAnalysisExcelAsDefault = !setAnalysisExcelAsDefault"
                                        class="relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus:outline-none"
                                        [ngClass]="setAnalysisExcelAsDefault ? 'bg-green-500' : 'bg-gray-200'">
                                        <span
                                            class="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
                                            [ngClass]="setAnalysisExcelAsDefault ? 'translate-x-4' : 'translate-x-0'"></span>
                                    </button>
                                </div>
                                }
                                <div (click)="onDownloadStandardAnalysisExcel()"
                                    class="text-sm font-medium text-white px-4 py-2 rounded-xl theme-bg hover:cursor-pointer">
                                    Generate excel
                                </div>
                                <app-button variant="outlined" severity="contrast" label="Upload" icon="pi pi-upload"
                                    iconPosition="left" (clicked)="openFileSelectionFor('analysisExcel')"></app-button>
                            </div>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col gap-3 pt-1">
                            <p class="text-xs text-gray-500">Download the example file <a
                                    (click)="downloadSample(GEOTECHNICAL_SAMPLE_DOWNLOAD_TYPE.EXAMPLE_EXCEL)"
                                    class="text-arena-orange hover:underline cursor-pointer">from here</a> and standard
                                file <a (click)="downloadSample(GEOTECHNICAL_SAMPLE_DOWNLOAD_TYPE.STANDARD_EXCEL)"
                                    class="text-arena-orange hover:underline cursor-pointer">from here</a>.</p>
                            <app-attachment-group [attachments]="analysisExcelFileAsChatAttachments"
                                [maxVisibleAttachments]="1" [canRemove]="true" [chips]="geoAttachmentChips"
                                (removeAttachment)="onRemoveAnalysisExcelAttachment()">
                            </app-attachment-group>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>
    </div>

    <!-- Step 2: Analysis information (two separate accordions) -->
    <div *stepperStep="stepperConfig()!.steps[1]">
        <div class="flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto">
            <!-- Accordion 0: Project Details -->
            <p-accordion [(value)]="analysisInfoProjectDetailsAccordionValue"
                class="w-full border border-gray-200 rounded-lg overflow-hidden">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <span class="text-sm font-semibold text-gray-900">Project Details</span>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col gap-5 py-4">
                            <!-- Project Area -->
                            <div class="flex flex-col gap-2">
                                <div class="flex items-center gap-1.5">
                                    <label class="text-sm font-semibold text-gray-900">Project Area <span
                                            class="text-red-500">*</span></label>
                                    <span class="flex items-center justify-center cursor-help"
                                        [pTooltip]="PROJECT_AREA_TOOLTIP" tooltipPosition="top">
                                        <app-icon type="info" source="lucide" size="sm"
                                            class="text-gray-400"></app-icon>
                                    </span>
                                </div>
                                <input pInputText type="number" [(ngModel)]="projectAreaValue" min="0"
                                    placeholder="Enter project area (SY)"
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
                            </div>
                            <!-- Shift Hours per Day -->
                            <div class="flex flex-col gap-2">
                                <div class="flex items-center gap-1.5">
                                    <label class="text-sm font-semibold text-gray-900">Shift Hours per Day <span
                                            class="text-red-500">*</span></label>
                                    <span class="flex items-center justify-center cursor-help"
                                        [pTooltip]="SHIFT_HOURS_TOOLTIP" tooltipPosition="top">
                                        <app-icon type="info" source="lucide" size="sm"
                                            class="text-gray-400"></app-icon>
                                    </span>
                                </div>
                                <input pInputText type="number" [(ngModel)]="shiftHoursPerDayValue" min="0"
                                    placeholder="Enter shift hours per day"
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
                            </div>
                            <!-- Theoretical Budget -->
                            <div class="flex flex-col gap-2">
                                <div class="flex items-center gap-1.5">
                                    <label class="text-sm font-semibold text-gray-900">Theoretical Budget ($) <span
                                            class="text-red-500">*</span></label>
                                    <span class="flex items-center justify-center cursor-help"
                                        [pTooltip]="THEORETICAL_BUDGET_TOOLTIP" tooltipPosition="top">
                                        <app-icon type="info" source="lucide" size="sm"
                                            class="text-gray-400"></app-icon>
                                    </span>
                                </div>
                                <input pInputText type="number" [(ngModel)]="theoreticalBudgetValue" min="0"
                                    placeholder="Enter theoretical budget"
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
                            </div>
                            <!-- Theoretical Schedule -->
                            <div class="flex flex-col gap-2">
                                <div class="flex items-center gap-1.5">
                                    <label class="text-sm font-semibold text-gray-900">Theoretical Schedule (Workdays)
                                        <span class="text-red-500">*</span></label>
                                    <span class="flex items-center justify-center cursor-help"
                                        [pTooltip]="THEORETICAL_SCHEDULE_TOOLTIP" tooltipPosition="top">
                                        <app-icon type="info" source="lucide" size="sm"
                                            class="text-gray-400"></app-icon>
                                    </span>
                                </div>
                                <input pInputText type="number" [(ngModel)]="theoreticalScheduleWorkdaysValue" min="0"
                                    placeholder="Enter theoretical schedule (workdays)"
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
                            </div>
                            <!-- Project Location -->
                            <div class="flex flex-col gap-2">
                                <div class="flex items-center gap-1.5">
                                    <label class="text-sm font-semibold text-gray-900">Project Location</label>
                                    <span class="flex items-center justify-center cursor-help"
                                        [pTooltip]="PROJECT_LOCATION_TOOLTIP" tooltipPosition="top">
                                        <app-icon type="info" source="lucide" size="sm"
                                            class="text-gray-400"></app-icon>
                                    </span>
                                </div>
                                <input pInputText type="text" [(ngModel)]="projectLocationValue"
                                    placeholder="Enter project location"
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
                            </div>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
            <!-- Accordion 1: Customisation -->
            <p-accordion [(value)]="analysisInfoCustomisationAccordionValue"
                class="w-full border border-gray-200 rounded-lg overflow-hidden">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <span class="text-sm font-semibold text-gray-900">Customization</span>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col gap-5 py-4">
                            <div class="flex flex-col gap-2">
                                <label class="text-sm font-semibold text-gray-900">Analysis name</label>
                                <input pInputText type="text" [(ngModel)]="analysisName"
                                    [placeholder]="ANALYSIS_NAME_PLACEHOLDER"
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50" />
                            </div>
                            <div class="flex flex-col gap-2">
                                <label class="text-sm font-semibold text-gray-900">Project</label>
                                <app-select [(value)]="selectedProject" [options]="analysisProjectOptions"
                                    [config]="{ placeholder: PROJECT_PLACEHOLDER, clearable: true, style: { width: '50%' }, appendTo: 'body' }"
                                    optionLabel="label" optionValue="value"
                                    (onChange)="onAnalysisInfoProjectChange($event.value ?? null)" />
                            </div>
                            <div class="flex flex-col gap-2 w-1/2">
                                <label class="text-sm font-semibold text-gray-900">Due date</label>
                                <app-datepicker [value]="analysisDueDate"
                                    (valueChange)="onAnalysisDueDateChange($event)" [config]="{
                                    placeholder: DUE_DATE_PLACEHOLDER,
                                    showIcon: true,
                                    dateFormat: 'dd M yy',
                                    appendTo: 'body',
                                    maxDate: analysisDueDateMax,
                                }" />
                            </div>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
            <!-- Accordion 2: Analysis milestones -->
            <p-accordion [(value)]="analysisInfoMilestonesAccordionValue"
                class="w-full border border-gray-200 rounded-lg overflow-hidden">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <span class="text-sm font-semibold text-gray-900">Analysis milestones</span>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col py-4">
                            <app-milestones [milestones]="$any(analysisMilestones)" [showHeader]="false"
                                [showActions]="false" [maxMilestoneDueDate]="getMilestonesMaxDate()"
                                [permissions]="analysisMilestonesPermissions"
                                (milestonesChange)="onAnalysisMilestonesChange($event)" class="h-full w-full" />
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>
    </div>

    <!-- Step 3: Team -->
    <div *stepperStep="stepperConfig()!.steps[2]">
        <div class="flex flex-col flex-1 min-h-0 overflow-y-auto">
            <div class="h-full min-h-0 flex flex-col">
                <app-share-to-users class="h-full w-full flex-1 min-h-0" [shareDetails]="analysisShareDetails"
                    [contract]="null" [isAnalysis]="true" (addUserToShare)="onAnalysisAddUserToShare($event)"
                    (removeUserFromShare)="onAnalysisRemoveUserFromShare($event)"
                    (updateSharedUser)="onAnalysisUpdateSharedUser($event)"
                    (changeSharedWithWorkspace)="onAnalysisChangeSharedWithWorkspace($event)"
                    (changeSharedWithProject)="onAnalysisChangeSharedWithProject($event)"
                    (changeAnyoneAccess)="onAnalysisChangeAnyoneAccess($event)">
                </app-share-to-users>
            </div>
        </div>
    </div>
</app-stepper>
}

<!-- Generate analysis excel sidebar (files sub-view only) -->
<p-drawer [(visible)]="showGenerateExcelSidebar" position="right" [style]="{ width: '22rem' }" [closable]="false"
    styleClass="generate-excel-sidebar">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full">
            <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 flex-shrink-0">
                <h2 class="text-lg font-semibold text-gray-900">Generate analysis excel</h2>
                <app-button variant="text" severity="contrast" icon="pi pi-times" iconSource="primeng"
                    (clicked)="closeGenerateExcelSidebar()" />
            </div>
            <!-- See all: file list panel -->
            <div class="flex flex-col flex-1 min-h-0">
                <app-button variant="text" severity="contrast" label="File name" icon="pi pi-chevron-left"
                    iconPosition="left" class="w-full justify-start px-4 py-3 border-b border-gray-100"
                    (clicked)="onSeeAllFilesBack()" />
                <div class="p-4 border-b border-gray-100 flex-shrink-0">
                    <div class="relative">
                        <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
                        <input type="text" [(ngModel)]="seeAllFilesSearchQuery" placeholder="Search with name"
                            class="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-gray-50 focus:bg-white focus:border-arena-orange focus:outline-none focus:ring-1 focus:ring-arena-orange" />
                    </div>
                </div>
                <div class="flex-1 min-h-0 overflow-y-auto flex flex-col gap-2">
                    @if (seeAllFilteredDocuments.length === 0) {
                    <div class="flex flex-1 items-center justify-center py-8 text-center">
                        <p class="text-sm text-gray-500">No files match your search.</p>
                    </div>
                    } @else {
                    @for (doc of seeAllFilteredDocuments; track doc._id) {
                    <div
                        class="flex items-center gap-3 p-3 rounded-lg border-b border-gray-200 bg-white hover:border-gray-300 transition-colors">
                        <div class="flex-shrink-0 w-15 h-15 rounded-lg flex items-center justify-center">
                            <app-file-icon [type]="getFileIconType(doc.name)" size="md"></app-file-icon>
                        </div>
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-medium text-gray-900 truncate">{{ doc.name || 'Unnamed file' }}</p>
                            <p class="text-xs text-gray-500">{{ formatFileSize(doc.size ?? 0) || '—' }}</p>
                        </div>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
    </ng-template>
</p-drawer>

<p-menu #agreementKebabMenu [model]="generateExcelAgreementMenuItems" [popup]="true"></p-menu>

<!-- Filter sidebar -->
<p-drawer [(visible)]="showFilterPanel" position="right" [style]="{ width: '22rem' }" [closable]="false">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full">
            <!-- Header -->
            <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 flex-shrink-0">
                <h2 class="text-lg font-semibold text-gray-900">Filter</h2>
                <app-button variant="text" severity="contrast" icon="pi pi-times" iconSource="primeng"
                    (clicked)="closeFilterPanel()" />
            </div>

            <!-- Filter fields -->
            <div class="flex flex-col gap-5 p-4 flex-1 overflow-y-auto">
                <!-- Project name -->
                <div class="flex flex-col gap-2">
                    <label class="text-sm font-semibold text-gray-900">Project name</label>
                    <app-select [(value)]="filterProject" [options]="analysisProjectOptions"
                        [config]="{ placeholder: 'Select project', clearable: true, appendTo: 'body' }"
                        optionLabel="label" optionValue="value" />
                </div>

                <!-- Creator name -->
                <div class="flex flex-col gap-2">
                    <label class="text-sm font-semibold text-gray-900">Creator name</label>
                    <app-multi-select [(value)]="filterCreatedBy" [options]="createdByOptions"
                        [config]="{ placeholder: 'Select creators', appendTo: 'body', showClear: true }"
                        optionLabel="label" optionValue="value" />
                    @if (filterCreatedBy.length > 0) {
                    <div class="flex flex-wrap gap-1.5 mt-1">
                        @for (id of filterCreatedBy; track id) {
                        <span
                            class="flex items-center gap-1 bg-blue-50 text-blue-700 text-xs font-medium px-2 py-1 rounded-base">
                            {{ getCreatorLabel(id) }}
                            <app-button variant="text" severity="contrast" icon="pi pi-times" iconSource="primeng"
                                size="xs" class="!p-0 !min-w-0 !h-auto text-blue-700 hover:text-blue-900"
                                (clicked)="removeCreatorFilter(id)" />
                        </span>
                        }
                    </div>
                    }
                </div>

                <!-- Due date -->
                <div class="flex flex-col gap-2">
                    <label class="text-sm font-semibold text-gray-900">Due date</label>
                    <app-datepicker [(value)]="filterDueDateRange" [config]="{
                        selectionMode: 'range',
                        placeholder: 'Select due date range',
                        showIcon: true,
                        dateFormat: 'dd M yy',
                        appendTo: 'body'
                    }" />
                </div>

                <!-- Date created -->
                <div class="flex flex-col gap-2">
                    <label class="text-sm font-semibold text-gray-900">Date created</label>
                    <app-datepicker [(value)]="filterDateCreatedRange" [config]="{
                        selectionMode: 'range',
                        placeholder: 'Select date created range',
                        showIcon: true,
                        dateFormat: 'dd M yy',
                        appendTo: 'body'
                    }" />
                </div>
            </div>

            <div class="flex items-center justify-end gap-2 p-3 border-t border-gray-200 flex-shrink-0">
                <app-button variant="outlined" severity="contrast" label="Clear" (clicked)="clearFilters()" />
                <app-button severity="primary" label="Apply" (clicked)="applyFilters()" />
            </div>
        </div>
    </ng-template>
</p-drawer>

<ng-template #integrationsConnectorsTemplate>
    <app-menu #connectorsMenu [items]="integrationsConnectorsMenuItems" [class]="'!max-h-[40vh] overflow-y-auto'"
        (itemSelected)="onIntegrationsConnectorSelect($event, connectorsMenu)" [pTooltip]="'Connectors'"
        tooltipPosition="top">
        <app-button [fullWidth]="true" [icon]="'blocks'" [iconSource]="'lucide'" [iconSize]="'default'"
            variant="outlined" severity="contrast" label="Connectors" (clicked)="connectorsMenu.toggle($event)" />
    </app-menu>
</ng-template>

<ng-template #fileSelectionEmptyState let-tab="tab" let-emptyMessage="emptyMessage"
    let-selectedDropdown="selectedDropdown">
    @if(tab?.id === 'INTEGRATIONS') {
    @if(getIntegrationConnectorConnected(selectedDropdown)) {
    <div class="flex flex-col items-center justify-center h-full text-gray-500">
        <img [src]="'images/bob_agent/404-bob.svg' | assetUrl" class="w-[80%]" />
        <p>{{ emptyMessage }}</p>
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center h-full text-gray-500 px-4">
        <img [src]="'images/integrations-no-connection.svg' | assetUrl" class="w-[80%] max-w-xs" />
        <p class="text-sm mt-1 text-center">Connect your apps to start importing files</p>
    </div>
    }
    }
</ng-template>

@if(openFileSelectionDialog) {
<app-file-selection [(visible)]="openFileSelectionDialog" [config]="fileSelectionConfig()" [fetch]="fileSelectionFetch"
    [dropdownOptions]="fileSelectionDropdownOptions()" [afterDropdownTemplate]="integrationsConnectorsTemplate"
    [afterDropdownTemplateTabId]="'INTEGRATIONS'" [emptyStateTemplate]="fileSelectionEmptyState"
    (onSubmit)="onFileSelectionSubmit($event)" (onCancel)="onFileSelectionCancel()">
</app-file-selection>
}

<p-dialog [(visible)]="uploadedFilesDialogVisible" [modal]="true" [closable]="false" [draggable]="false" appendTo="body"
    (onHide)="closeUploadedFilesDialog()" styleClass="uploaded-files-dialog" [style]="uploadedFilesDialogStyle"
    [contentStyle]="uploadedFilesDialogContentStyle">
    <ng-template pTemplate="header">
        <div class="flex items-center justify-between w-full pr-1">
            <h2 class="text-lg font-semibold text-gray-900">Uploaded files</h2>
            <app-button variant="text" severity="contrast" icon="pi pi-times" iconSource="primeng"
                (clicked)="closeUploadedFilesDialog()" />
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="flex flex-col flex-1 min-h-0 gap-4">
            <div class="relative flex-shrink-0">
                <span
                    class="absolute left-3 top-1/2 -translate-y-1/2 flex items-center justify-center pointer-events-none">
                    <app-icon type="search" source="lucide" size="sm" class="text-gray-500"></app-icon>
                </span>
                <span class="absolute left-9 top-1/2 -translate-y-1/2 w-px h-4 bg-gray-200 pointer-events-none"></span>
                <input type="text" [(ngModel)]="seeAllFilesSearchQuery" placeholder="Search with name..."
                    class="w-full pl-12 pr-4 py-2.5 text-sm border border-gray-200 rounded-lg bg-gray-100 focus:bg-white focus:border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300" />
            </div>
            <div class="flex-1 min-h-0 overflow-y-auto rounded-lg bg-gray-100">
                @if (seeAllFilteredDocuments.length === 0) {
                <div class="flex items-center justify-center py-12 text-center">
                    <p class="text-sm text-gray-500">No files match your search.</p>
                </div>
                } @else {
                <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 p-3">
                    @for (doc of seeAllFilteredDocuments; track doc._id) {
                    <div
                        class="flex flex-col gap-2 p-3 rounded-lg bg-white border border-gray-200 hover:border-gray-300 transition-colors">
                        <div class="flex-shrink-0 w-10 h-10 rounded flex items-center justify-center bg-red-50">
                            <app-file-icon [type]="getFileIconType(doc.name)" size="md"></app-file-icon>
                        </div>
                        <p class="text-sm font-medium text-gray-900 truncate" [title]="doc.name">{{ doc.name || 'Unnamed
                            file' }}</p>
                        <p class="text-xs text-gray-500">{{ formatFileSize(doc.size ?? 0) || '—' }}</p>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </ng-template>
</p-dialog>

<app-dialog [(visible)]="renameAgreementDialogVisible" class="max-w-sm" header="Rename">
    <ng-template #headerTemplate>
        <h3 class="text-base font-semibold">Rename</h3>
    </ng-template>
    <div class="flex flex-col gap-3 py-2">
        <input pInputText type="text" [(ngModel)]="renameAgreementValue" placeholder="Enter new name" class="w-full"
            (keydown.enter)="onRenameAgreementConfirm()" />
    </div>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end gap-2">
            <app-button variant="outlined" (clicked)="renameAgreementDialogVisible = false">Cancel</app-button>
            <app-button variant="primary" [disabled]="!renameAgreementValue.trim()" [loading]="renamingAgreement"
                (clicked)="onRenameAgreementConfirm()">Rename</app-button>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="deleteAgreementDialogVisible" class="max-w-sm" header="Delete Analysis">
    <ng-template #headerTemplate>
        <h3 class="text-base font-semibold">Delete Analysis Excel</h3>
    </ng-template>
    <div class="flex flex-row items-start gap-3 py-2">
        <span class="flex flex-shrink-0 w-10 h-10 rounded-full bg-red-100 items-center justify-center">
            <i class="pi pi-trash text-red-600 text-lg" aria-hidden="true"></i>
        </span>
        <p class="text-gray-600 text-sm m-0">Are you sure you want to delete this analysis excel? This action cannot be
            undone.</p>
    </div>
    <ng-template #footerTemplate>
        <div class="flex flex-row justify-end gap-2">
            <app-button variant="outlined" (clicked)="deleteAgreementDialogVisible = false">Cancel</app-button>
            <app-button variant="filled" severity="danger" [loading]="deletingAgreement"
                (clicked)="onDeleteAgreementConfirm()">Delete</app-button>
        </div>
    </ng-template>
</app-dialog>

@if(analysisExcelPreview) {
<p-dialog [(visible)]="analysisExcelPreviewVisible" [modal]="true" [closable]="true" [draggable]="false" appendTo="body"
    styleClass="analysis-excel-preview-dialog" maskStyleClass="analysis-excel-preview-mask"
    (onHide)="closeAnalysisExcelPreview()" [style]="{ width: '90vw', height: '90vh' }"
    [contentStyle]="{ height: 'calc(90vh - 4rem)', padding: '0', overflow: 'hidden' }">
    <ng-template pTemplate="header">
        <span class="font-semibold text-base">{{ analysisExcelPreview.name }}</span>
    </ng-template>
    <app-only-office-doc-editor class="block h-full w-full" [contractId]="analysisExcelPreview.id"
        [configData]="analysisExcelEditor" [editorId]="'analysis_excel_' + analysisExcelPreview.id">
    </app-only-office-doc-editor>
</p-dialog>
}


<!-- ── Configurations drawer ────────────────────────────────────────────── -->
<p-drawer [(visible)]="showConfigurationsDrawer" position="right" [style]="{ width: '22rem' }" [closable]="false"
    styleClass="configurations-sidebar">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full">
            <!-- Drawer header -->
            <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 flex-shrink-0">
                <h2 class="text-lg font-semibold text-gray-900">Configuration</h2>
                <app-button variant="text" severity="contrast" icon="pi pi-times" iconSource="primeng"
                    (clicked)="closeConfigurationsDrawer()" />
            </div>

            <!-- Configuration sections list -->
            <div class="flex flex-col flex-1 overflow-y-auto divide-y divide-gray-100">

                <!-- AI Dashboard Instructions section (Account Owner / Org Admins / Workspace Admins only) -->
                @if (canManageInstructions) {
                <div class="p-4 flex flex-col gap-2">
                    <!-- Section header row: title + pencil icon to enter edit mode -->
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                            <app-icon type="layout-dashboard" source="lucide" size="sm"
                                class="text-gray-500 flex-shrink-0" />
                            <span class="text-sm font-medium text-gray-800">AI Dashboard Instructions</span>
                        </div>
                        @if (!aiDashboardEditing()) {
                        <app-button variant="text" severity="contrast" icon="pencil" [iconSource]="'lucide'"
                            pTooltip="Edit instructions" tooltipPosition="left"
                            (clicked)="startEditAiDashboardInstructions()" />
                        }
                    </div>

                    @if (!aiDashboardEditing()) {
                    <!-- Read-mode: preview current value or empty state hint -->
                    <p class="text-sm text-gray-500 whitespace-pre-wrap break-words leading-relaxed max-h-32 overflow-y-auto"
                        [class.italic]="!aiDashboardInstructions()">
                        {{ aiDashboardInstructions() || 'No instructions added. Click the pencil icon to configure.' }}
                    </p>
                    } @else {
                    <!-- Edit mode: editable textarea -->
                    <textarea rows="8"
                        class="w-full resize-y rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 leading-relaxed focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent placeholder:text-gray-400 max-h-48"
                        placeholder="Describe how the AI Dashboard should be structured, what sections to include, preferred chart types, etc."
                        [value]="aiDashboardDraft()" (input)="aiDashboardDraft.set($any($event.target).value)">
                    </textarea>
                    <div class="flex justify-end gap-2 mt-1">
                        <app-button variant="outlined" severity="contrast" label="Cancel"
                            (clicked)="cancelEditAiDashboardInstructions()" />
                        <app-button variant="filled" severity="primary" label="Save" [loading]="aiDashboardSaving()"
                            (clicked)="saveAiDashboardInstructions()" />
                    </div>
                    }
                </div>
                }

                <!-- Summary Instructions section (Account Owner / Org Admins / Workspace Admins only) -->
                @if (canManageInstructions) {
                <div class="p-4 flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                            <app-icon type="file-text" source="lucide" size="sm" class="text-gray-500 flex-shrink-0" />
                            <span class="text-sm font-medium text-gray-800">Summary Instructions</span>
                        </div>
                        @if (!summaryEditing()) {
                        <app-button variant="text" severity="contrast" icon="pencil" [iconSource]="'lucide'"
                            pTooltip="Edit instructions" tooltipPosition="left"
                            (clicked)="startEditSummaryInstructions()" />
                        }
                    </div>

                    @if (!summaryEditing()) {
                    <p class="text-sm text-gray-500 whitespace-pre-wrap break-words leading-relaxed max-h-32 overflow-y-auto"
                        [class.italic]="!summaryInstructions()">
                        {{ summaryInstructions() || 'No instructions added. Click the pencil icon to configure.' }}
                    </p>
                    } @else {
                    <textarea rows="8"
                        class="w-full resize-y rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 leading-relaxed focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent placeholder:text-gray-400 max-h-48"
                        placeholder="Describe how the Summary should be structured, what sections to include, etc."
                        [value]="summaryDraft()" (input)="summaryDraft.set($any($event.target).value)">
                    </textarea>
                    <div class="flex justify-end gap-2 mt-1">
                        <app-button variant="outlined" severity="contrast" label="Cancel"
                            (clicked)="cancelEditSummaryInstructions()" />
                        <app-button variant="filled" severity="primary" label="Save" [loading]="summarySaving()"
                            (clicked)="saveSummaryInstructions()" />
                    </div>
                    }
                </div>
                }

                <!-- Round layer thickness toggle (Account Owner / Org Admins / Workspace Admins only) -->
                @if (canManageInstructions) {
                <div class="p-4 flex flex-col gap-2">
                    <div class="flex items-center justify-between gap-2">
                        <div class="flex items-center gap-2">
                            <app-icon type="ruler" source="lucide" size="sm" class="text-gray-500 flex-shrink-0" />
                            <span class="text-sm font-medium text-gray-800">Round layer thickness</span>
                        </div>
                        <app-toggle [ngModel]="roundLayerThickness()" [disabled]="roundLayerThicknessSaving()"
                            (onChange)="onRoundLayerThicknessToggle($event)">
                        </app-toggle>
                    </div>
                    <p class="text-sm text-gray-500 leading-relaxed">
                        When on, layer thickness values (e.g. Base, Sub-grade) are rounded to the nearest whole
                        inch across all geotechnical reports in this workspace.
                    </p>
                </div>
                }

                <!-- Generate Analysis Excel section -->
                <div class="p-4 flex flex-col gap-3">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                            <app-icon type="file-spreadsheet" source="lucide" size="sm"
                                class="text-gray-500 flex-shrink-0" />
                            <span class="text-sm font-medium text-gray-800">Generate Analysis Excel</span>
                        </div>
                        <app-button variant="outlined" severity="contrast" icon="pi pi-plus" iconSource="primeng"
                            pTooltip="Generate excel" tooltipPosition="left"
                            (clicked)="openFileSelectionFor('generateAnalysisExcel')" />
                    </div>

                    @if (loadingGenerateExcelAgreements) {
                    <div class="flex items-center justify-center py-4">
                        <i class="pi pi-spin pi-spinner text-xl text-gray-400"></i>
                    </div>
                    } @else if (generateExcelAgreementItems.length === 0) {
                    <p class="text-sm text-gray-500 text-center py-4 italic">No generated analysis excels yet. Use the +
                        button to create one.</p>
                    } @else {
                    <div class="flex flex-col">
                        @for (item of generateExcelAgreementItems; track item.id) {
                        <div
                            class="flex flex-col gap-2 pb-5 rounded-lg border-b border-gray-200 bg-white hover:border-gray-300 transition-colors">
                            <div class="flex items-center gap-2 min-w-0">
                                <app-file-icon [type]="getFileIconType('.xlsx')" size="md"
                                    class="flex-shrink-0"></app-file-icon>
                                <span class="text-sm font-medium text-gray-900 truncate flex-1 min-w-0">{{ item.name
                                    }}</span>
                                <button type="button" [disabled]="!item.source?.analysis"
                                    (click)="toggleAgreementSelection(item); $event.stopPropagation()"
                                    (keydown.enter)="toggleAgreementSelection(item); $event.stopPropagation()"
                                    (keydown.space)="toggleAgreementSelection(item); $event.stopPropagation(); $event.preventDefault()"
                                    [attr.aria-pressed]="item.selected"
                                    [pTooltip]="!item.source?.analysis ? 'Excel is still being generated' : ''"
                                    tooltipPosition="top"
                                    class="relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors focus:outline-none focus:ring-2 focus:ring-arena-orange focus:ring-offset-2"
                                    [ngClass]="item.selected ? 'bg-arena-orange' : 'bg-gray-200'"
                                    [class.cursor-pointer]="item.source?.analysis"
                                    [class.cursor-not-allowed]="!item.source?.analysis"
                                    [class.opacity-50]="!item.source?.analysis">
                                    <span class="sr-only">Toggle selection</span>
                                    <span
                                        class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition-transform"
                                        [ngClass]="item.selected ? 'translate-x-5' : 'translate-x-0.5'"></span>
                                </button>
                                <app-menu #agreementRowMenuDrawer [items]="agreementRowMenuItems"
                                    (itemSelected)="onAgreementMenuAction($event)">
                                    <app-button variant="text" severity="contrast" icon="pi pi-ellipsis-v"
                                        iconSource="primeng" class="flex-shrink-0"
                                        (clicked)="onAgreementMenuButtonClick($event, item, agreementRowMenuDrawer); $event.stopPropagation()" />
                                </app-menu>
                            </div>
                            <div class="flex items-center justify-between gap-1.5">
                                <div class="flex items-center gap-0">
                                    @for (doc of item.source?.documents; track doc._id) {
                                    <span class="flex items-center justify-center w-5 h-5 flex-shrink-0"
                                        title="{{ doc.type }}">
                                        <app-file-icon [type]="getFileIconType(doc.type)" size="md"></app-file-icon>
                                    </span>
                                    }
                                </div>
                                @if (item.fileCount > 0) {
                                <span class="text-xs text-gray-500">{{ item.fileCount > 4 ? '4+' : ''}}</span>
                                }
                                <div (click)="onSeeAllAgreementFiles(item)"
                                    class="flex items-center gap-1 cursor-pointer">
                                    <span class="text-xs text-gray-500 hover:underline font-medium">See all</span>
                                    <app-icon type="chevron-right" source="lucide" size="sm"
                                        class="text-gray-500"></app-icon>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>

            </div>
        </div>
    </ng-template>
</p-drawer>
